import { LoaderCircle } from 'lucide-react';
import { cn } from '@shared/lib/cn';

export interface SpinnerProps {
  size?: number;
  className?: string;
  /** Accessible label; omit when the surrounding element already announces the busy state. */
  label?: string;
}

export function Spinner({ size = 16, className, label }: SpinnerProps) {
  return (
    <LoaderCircle
      size={size}
      strokeWidth={1.5}
      className={cn('spin shrink-0', className)}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
    />
  );
}
